import { InjectionToken } from '@angular/core';

/**
 * Minimal logger interface consumed by the auth library. Defaults to `console`; the shell can provide a structured
 * logging service (e.g. LoggerService from @conductor/observability) via this token.
 */
export interface IAuthLogger {
  warn(message: string, ...args: unknown[]): void;
  error(message: string, ...args: unknown[]): void;
  log(message: string, ...args: unknown[]): void;
}

export const AUTH_LOGGER = new InjectionToken<IAuthLogger>('AUTH_LOGGER', {
  providedIn: 'root',
  factory: () => console,
});
